import React, { useContext, useEffect, useState, useRef } from 'react';
import { store } from './Tendering';
import { store as mainStore } from '../../../../../store';
import { localText } from '../../../../../langs/fa/data-grid';
import DataGrid from '../../../../../components/DataGrid/DataGrid';
import NoBidders from './NoBidders';
import Rating from '@material-ui/lab/Rating';
import { makeStyles } from '@material-ui/core/styles';
import User from '../../../../../components/User/UserAvatar';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import BiddersCommandsList from './BiddersCommandsList';
import { formatNumber } from 'fns';
import DriverLocation from '../../../../../components/Dialog/DriverLocation';
import { isMobile } from 'react-device-detect';
import { useQuery } from 'react-query';

const useStyles = makeStyles((theme) => ({
  stars: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  root: {
    width: '100%',
    height: isMobile ? 'unset' : 680,
    '& .confirmed': {
      background: '#1b5e20',
      color: '#fff',
    },
    '& .checked': {
      background: '#c8e6c9',
    },
    '& .green': {
      background: '#01579b',
      color: '#fff',
    },
    '& .red': {
      background: '#ef9a9a',
      color: '#b71c1c',
    },
  },
}));

const ListBidders = () => {
  const classes = useStyles();
  const {
    state: { order, bidders, params, biddersPage },
    dispatch,
    actions: { fetchingBidders },
  } = useContext(store);
  const {
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const [values, setValues] = useState({ loading: true });
  const { loading } = values;
  const [anchorEl, setAnchorEl] = useState(null);
  const [driver, setDriver] = useState(null);
  const columns = [
    {
      field: 'name',
      headerName: 'نام',
      flex: 1,
      renderCell: (param) => <User user={param.value.user} fullName />,
      cellClassName: (param) => {
        if (order.drivers.includes(param.value._id)) return 'confirmed';
        else if (order.driversSelected.includes(param.value._id))
          return 'checked';
        else return '';
      },
    },
    {
      field: 'totalWaybillAmount',
      headerName: 'کرایه کل',
      width: 150,
      renderCell: (param) =>
        param.value?.propose && param.value?.totalCommissions
          ? formatNumber(
              param.value.propose * 1 + param.value?.totalCommissions * 1
            )
          : 'نامشخص',
      cellClassName: (param) => {
        if (order.drivers.includes(param.value._id)) return 'confirmed';
        else if (order.driversSelected.includes(param.value._id))
          return 'checked';
        else return '';
      },
    },
    {
      field: 'bidderPropose',
      headerName: 'پیشنهادراننده',
      width: 150,
      renderCell: (param) =>
        param.value?.propose ? formatNumber(param.value.propose * 1) : 'نامشخص',
      cellClassName: (param) => {
        if (order.drivers.includes(param.value._id)) return 'confirmed';
        else if (order.driversSelected.includes(param.value._id))
          return 'checked';
        else return '';
      },
    },
    {
      field: 'totalCommissions',
      headerName: 'کمیسیون دریافتی',
      width: 180,
      renderCell: (param) =>
        param.value?.totalCommissions
          ? formatNumber(param.value.totalCommissions)
          : 'نامشخص',
      cellClassName: (param) => {
        if (order.drivers.includes(param.value._id)) return 'confirmed';
        else if (order.driversSelected.includes(param.value._id))
          return 'checked';
        else return '';
      },
    },
    {
      field: 'companyCommission',
      headerName: 'کارمزد شرکت',
      width: 180,
      renderCell: (param) =>
        param.value?.companyCommission
          ? formatNumber(param.value.companyCommission)
          : 'نامشخص',
      cellClassName: (param) => {
        if (order.drivers.includes(param.value._id)) return 'confirmed';
        else if (order.driversSelected.includes(param.value._id))
          return 'checked';
        else return '';
      },
    },
    {
      field: 'differ',
      headerName: 'اختلاف',
      width: 120,
      renderCell: (param) =>
        param.value.propose
          ? order.proposedPrice
            ? formatNumber(
                order.proposedPrice -
                  (param.value.propose * 1 + params?.subs * 1 || 0)
              )
            : 'توافقی'
          : 'نامشخص',
      cellClassName: (param) => {
        if (!param.value.propose) return '';
        if (
          order.proposedPrice * 1 -
            (param.value.propose * 1 + params?.subs * 1 || 0) >
          0
        )
          return 'confirmed';
        else if (
          order.proposedPrice * 1 -
            (param.value.propose * 1 + params?.subs * 1 || 0) ===
          0
        )
          return '';
        else if (
          order.proposedPrice * 1 -
            (param.value.propose * 1 + params?.subs * 1 || 0) <
          0
        )
          return 'red';
        else if (order.drivers.includes(param.value._id)) return 'confirmed';
        else if (order.driversSelected.includes(param.value._id))
          return 'checked';
        return '';
      },
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 120,
      renderCell: (param) => {
        if (
          order.drivers &&
          order.drivers.length &&
          order.drivers.includes(param.value._id)
        )
          return '✅';
        if (
          order.driversSelected &&
          order.driversSelected.length &&
          order.driversSelected.includes(param.value._id)
        )
          return 'انتتخاب‌راننده';
        if (param.value.propose) return 'پیشنهاد‌راننده';
        else return 'نامشخص';
      },
      cellClassName: (param) => {
        if (order.drivers.includes(param.value._id)) return 'confirmed';
        else if (order.driversSelected.includes(param.value._id))
          return 'checked';
        else return '';
      },
    },
    {
      field: 'command',
      headerName: 'فرمان',
      width: 100,
      renderCell: (param) => {
        return (
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={handleClickButton}
          >
            انتخاب
          </Button>
        );
      },
      cellClassName: (param) => {
        if (order.drivers.includes(param.value._id)) return 'confirmed';
        else if (order.driversSelected.includes(param.value._id))
          return 'checked';
        else return '';
      },
    },
    {
      field: 'gps',
      headerName: '📍',
      width: 80,
      renderCell: (param) => <DriverLocation driver={param.value} />,
      cellClassName: (param) => {
        if (order.drivers.includes(param.value._id)) return 'confirmed';
        else if (order.driversSelected.includes(param.value._id))
          return 'checked';
        else return '';
      },
    },
  ];
  const handlePageChange = async ({ page }) => {
    dispatch({ type: 'CHANGE_BIDDERS_PAGE', payload: page });
  };
  const handleSelectDriver = (selection) => {
    const driverId = selection.row.id;
    const driver = bidders.docs.find((b) => b._id === driverId);
    setDriver(driver);
  };
  const handleClickButton = (e) => {
    setAnchorEl(e.currentTarget);
  };

  async function getBidders() {
    try {
      const drivers = await fetchingBidders(
        order._id,
        biddersPage,
        itemsCountPerPage
      );
      setValues({ ...values, loading: false });
      dispatch({ type: 'BIDDERS', payload: drivers });
      return drivers;
    } catch (error) {
      console.error(error);
    }
  }

  const { data, isLoading, refetch } = useQuery(
    ['tenderingListBidders', biddersPage],
    () => getBidders(),
    { refetchOnWindowFocus: false }
  );

  return (
    <div className={classes.root}>
      <DataGrid
        rows={
          data?.docs?.map((driver) => ({
            id: driver._id,
            name: driver,
            totalWaybillAmount: driver,
            bidderPropose: driver,
            totalCommissions: driver,
            companyCommission: driver,
            differ: driver,
            status: driver,
            command: driver,
            gps: driver,
          })) || []
        }
        columns={columns}
        localeText={localText}
        pageSize={Number(itemsCountPerPage)}
        rowCount={data?.totalDocs || 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={isLoading}
        disableMultipleSelection
        density="compact"
        components={{
          noRowsOverlay: NoBidders,
        }}
        onCellClick={handleSelectDriver}
      />
      {driver && (
        <Popover
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <div style={{ width: 350, background: '#fff' }}>
            <BiddersCommandsList
              driver={driver}
              order={order}
              onClose={() => setAnchorEl(null)}
              refetch={refetch}
            />
          </div>
        </Popover>
      )}
    </div>
  );
};

export default React.memo(ListBidders);
